import React from 'react';
import FooterLink from '../FooterLink/FooterLink';
import Header from '../Header/Header';
import aboutVector from './../../assets/about_vector.png';
import './About.css';
import aboutAnime from './../../assets/about_anime.gif';

const About = () => {
    return (
      <div className="section-container">
        <Header heading="About Me." />
        <div className="about-main">
          <div className="about-main-left">
            <p className="about-details">
              Hi, I'm Gurpreet Singh, a passionate self-taught Full-Stack web
              Developer from India currently working as a Software Engineering
              Analyst at Accenture. I am an enthusiastic person who genuinely
              wants to develop the necessary skills and qualities to have a
              successful career and future. I keep myself motivated and active
              and always ready to learn new things and accept new challenges
            </p>

            <FooterLink
          phrase="Check out my "
          link="projects!"
          toAdress="/projects"
        />
          </div>

          <div className="about-main-right">
            <img src={aboutAnime} alt="animation" className="about-anime" />
          </div>
        </div>

      
        {/* Vector Frame! */}
        <div className="vector-frame">
          <img src={aboutVector} className="about-vector" alt="about" />
        </div>
      </div>
    );
};

export default About;
